module.exports = __webpack_public_path__ + "img/user07.75959d18.jpg";